<template>
	<div>
		<div
			class="modal fade product-tags"
			id="updateWorkStatus"
			tabindex="-1"
			role="dialog"
			aria-labelledby="updateWorkStatus"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content product-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Update Product Alert Work Status</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body" style="margin-top:25px" v-else>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Update Work Status</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="newStatus"
								    :options="statusOptions.map( s => ({title: String(s), value: String(s)}))"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addNewStatus($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select or Enter New Work Status"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="workStatus"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								:disabled="this.newStatus.length === 0"
								type="button"
								class="btn btn-primary"
								@click = "updateWorkStatus()"
								>Save changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "UpdateWorkStatus",
		components: {
			Multiselect
		},
		data() {
			return {
				selectedproducts:[],
				newStatus:[],
				isLoading:false
			};
		},
		mounted() {
		},
		computed: {
			statusOptions: {
				set(val) {
				},
				get() {
					return this.$store.state.productAlerts.filterOptions 
					&& this.$store.state.productAlerts.filterOptions.work_status 
					? this.$store.state.productAlerts.filterOptions.work_status : [];
				}
			}
		},
		methods: {
			addNewStatus(name){
				let pay = { title: name }
				this.newStatus = pay
			},
			hideModal(){
				this.$emit('closeModal')
			},
			async updateWorkStatus(){
				let partneruuid, marketplaceId
				if (this.$store.state.productAlerts.selectedAccount ) {
					partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
					marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id
				}
				const payload = {
					...this.$store.state.productAlerts.issueFilters, 
					partneruuid, 
					marketplaceId, 
					newStatus: this.newStatus.title,
					selectAll: this.$store.state.productAlerts.actionSelectionControl,
					selectedProducts: this.$store.state.productAlerts.selectedIssues
				}
				this.hideModal()
				await this.$store.dispatch("productAlerts/setWorkedStatus", payload)
				await this.refreshProductAlerts()
				this.$store.state.productAlerts.selectedIssues = []
			},
			async refreshProductAlerts(){
				this.$store.state.currentPageNumber = 1
				const partneruuid = this.$store.state.productAlerts.selectedAccount.partneruuid
				const marketplaceId = this.$store.state.productAlerts.selectedAccount.marketplace_id

				const vm = this
				await this.$store.dispatch("productAlerts/list", {partneruuid, marketplaceId}).then(res => {
					vm.$store.state.productAlerts.issuesList = res
				})
			}
		}
	};
</script>


<style lang="scss">
.product-tags {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.product-tags {
	.multiselect__option span{
		text-transform: none !important;
	}
}
.product-tags {
	.multiselect__tag{
		text-transform: none !important;
	}
}

</style>
